import { render, staticRenderFns } from "./DeletePermissionProfiles.vue?vue&type=template&id=57a31f94&"
import script from "./DeletePermissionProfiles.vue?vue&type=script&lang=js&"
export * from "./DeletePermissionProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports